<template>
  <div class="news" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
<!--          <el-button class="btn animation">查看更多</el-button>-->
        </div>
      </div>
      <div class="step2" data-step="b">
          <div class="customer-content" >
            <div class="fnt-32-bold animationToBottom">
              {{dataList[0].title}}
            </div>
            <div class="animation" v-show="show1">
              <div class="customer-content-child">
                <img v-for="(item, index) in dataList" :key="index"
                     :src="item.img"/>
              </div>
              <el-pagination
                @current-change="currentChange"
                style="padding: 0 0 50px"
                :page-size="pageSize"
                :current-page="pageNum"
                layout="prev, pager, next"
                :total="newsList.length">
              </el-pagination>
            </div>
          </div>
      </div>
      <div class="step3" data-step="c">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      pageSize: 16,
      pageNum: 1,
      newsList: [],
      dataList: [],
      textData: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    },
    currentChange (index) {
      this.pageNum = index
      this.loadData()
      document.getElementById('news').scrollTop = 300
    },
    loadData () {
      this.dataList = this.newsList.slice((this.pageNum - 1) * this.pageSize, this.pageSize * this.pageNum)
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[1]
      this.newsList = this.$boss.page515.g515.reverse()
      this.loadData()
    }
  }
}
</script>
<style scoped lang="less">
.news{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  div{
    //一级标题
    .first-level-title{
      font-size: 42px;
      font-weight: 500;
      color:#323232;
    }
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 71vh;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        font-size: 52px;
        opacity: 0;
        margin-top: -45vh;
        font-weight: bold;
        color: #fff;
        padding-left: 100px;
      }

      .content {
        padding-left: 100px;
        font-size: 32px;
        opacity: 0;
        margin-top: 40px;
        color: #E6E9F3;
      }

      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .customer-content {
      min-height: 800px;
      width: 100%;
      background: url("../../../static/images/aboutUs/customer/bg.png") no-repeat;
      background-size: 100% 100%;
      &-child{
        width: calc(100% - 200px);
        /*margin-left: 100px;*/
        height: 600px;
        text-align: left;
        padding: 100px;
        display: flex;
        /*position: absolute;*/
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        img {
          /*margin: 0 0.5%;*/
          height: 150px;
          /*width: 20%;*/
          width: 25%;
        }
        img:hover {
          transform: scale(1.05);
        }
      }
      /deep/ .el-pagination button:disabled, /deep/ .el-pager li, /deep/ .el-pagination button {
        color: #8c939d;
        background: transparent;
        font-size: 24px;
      }
      /deep/ .el-pager li.active {
        color: #003f92;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/customerCase/index.vue